'use client';
import { createContext, useContext } from 'react';
const ComputerCommandMenuCatalogImplementationContext = createContext(undefined);
export const ComputerCommandMenuCatalogImplementationProvider = ComputerCommandMenuCatalogImplementationContext.Provider;
export function useComputerCommandMenuCatalogImplementation() {
    return useContext(ComputerCommandMenuCatalogImplementationContext);
}
//# sourceMappingURL=computerCommandMenuCatalogImplementationShared.js.map